

import './CollectionItem.css';
import {items} from '../../collectionsData';
import ItemCard from '../../components/ItemCard/ItemCard';

const CollectionItem = () => {
    return(
        <div className='bg-white dark:bg-dark-content-bg dark:text-white transition-colors duration-300 ease-in-out'>

            <div className="h-[35vh] collection_item_container">
            </div>

            <div className="max-w-[1600px] mx-auto px-4">

                <div className="flex justify-center w-full">
                    <div className="w-full max-w-[70px] sm:max-w-[100px] lg:max-w-[150px] 2xl:max-w-[200px] relative -top-[35px] md:-top-[50px] lg:-top-[75px] 2xl:-top-[100px] -mb-[35px] md:-mb-[50px] lg:-mb-[75px] 2xl:-mb-[100px]">
                        <img src = {require('../../assets/images/collectionItem/profileimage.png')} alt = 'collectionimage' className = 'w-full h-full object-cover rounded-full'/>
                    </div>
                </div>
                <div className='flex flex-col items-center w-full mt-4'>
                    
                    <h1 className='text-center font-bold text-xl sm:text-2xl lg:text-3xl max-w-[27ch] mb-4'>Solana Monkey Business</h1>
            
                    <p className='text-center text-[#595959] dark:text-[#F2F2F2] font-medium text-base sm:text-lg max-w-[870px] mb-[26px]'>
                        SMB is a collection of 5000 randomly generated 24x24 pixels NFTs on the Solana Blockchain. Each SolanaMonkey is unique and comes with different type and attributes varying in rarity.
                    </p>
                    
                    <div className='grid grid-cols-2 md:grid-cols-4 mt-5'>

                        <div className='flex flex-col justify-center items-center p-3 m-3 shadow-shadow3 rounded-[7px] dark:bg-dark-card'>
                            <p className='text-center sm:text-lg lg:text-xl max-w-[30ch] font-bold'>3K</p>
                            <p className='text-center text-[#595959] dark:text-[#F6F6F6] text-base sm:text-lg lg:text-xl max-w-[30ch]'>Items</p>
                        </div>
                        <div className='flex flex-col justify-center items-center p-3 m-3 shadow-shadow3 rounded-[7px] dark:bg-dark-card'>
                            <p className='text-center text-base sm:text-lg lg:text-xl max-w-[30ch] font-bold'>2.6K</p>
                            <p className='text-center text-[#595959] dark:text-[#F6F6F6] text-base sm:text-lg lg:text-xl max-w-[30ch]'>Owners</p>
                        </div>
                        <div className='flex flex-col justify-center items-center p-3 m-3 shadow-shadow3 rounded-[7px] dark:bg-dark-card'>
                            <div className='flex '>                             
                                <p className='text-center text-base sm:text-lg lg:text-xl max-w-[30ch] font-bold'>OC</p>
                            </div>
                            <p className='text-center text-[#595959] dark:text-[#F6F6F6] text-base sm:text-lg lg:text-xl max-w-[30ch]'>Floor Price</p>
                        </div>
                        <div className='flex flex-col justify-center items-center p-3 m-3 shadow-shadow3 rounded-[7px] dark:bg-dark-card'>
                            <div className='flex'>
                                <p className='text-center text-base sm:text-lg lg:text-xl max-w-[30ch] font-bold'>854.8K</p>
                            </div>
                            <p className='text-center text-[#595959] dark:text-[#F6F6F6] text-base sm:text-lg lg:text-xl max-w-[30ch]'>Volume Traded</p>
                        </div>

                    </div>
            
                </div>

            </div>

            <div className='py-8 mt-8 px-5'>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {items.map((item, index) => {
                        if(index < 12){
                            return(
                                <ItemCard item = {item} key = {index}/>
                            )
                        }
                        else return null;
                    })}
                </div>
                

            </div>
            

        </div>        
    )
}

export default CollectionItem;